module.exports = __webpack_public_path__ + "stockLibrary/simulator/011-978f516c76b343063b58abd33bb39e47.png";